import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-002fb01b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "line-chip-container" }
const _hoisted_3 = { class: "line-name" }
const _hoisted_4 = { class: "campus-name" }
const _hoisted_5 = { class: "line-info-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow" }, " → ", -1 /* HOISTED */))
const _hoisted_7 = { class: "buttons-wrapper" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createCommentVNode(" 칩, 경로보기 버튼 "),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["LineSetTypeChip"], {
        class: "line-type-chip",
        lineTypeCode: $props.lineInfo.lineTypeCode,
        lineTypeName: $props.lineInfo.lineTypeName,
        lineTurns: $props.selectedTurn ? [$props.selectedTurn] : [],
        hideDayOfWeek: true
      }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName", "lineTurns"])
    ]),
    _createCommentVNode(" 노선명 "),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString($setup.useGetLineRouteName(
            $props.lineInfo.lineTypeCode,
            $props.lineInfo.routeName,
            $props.lineInfo.lineNum
          )), 1 /* TEXT */),
      ($setup.shouldShowBookChip)
        ? (_openBlock(), _createBlock($setup["BookChip"], {
            key: 0,
            class: "line-header-book-chip"
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString($props.lineInfo.campusName), 1 /* TEXT */),
    _createElementVNode("p", _hoisted_5, [
      _createCommentVNode(" <span>{{ selectedTurn?.lineTimeName ?? \"-\" }}</span>\n      <span class=\"divider\">&nbsp; | &nbsp;</span> "),
      _createElementVNode("span", null, _toDisplayString($setup.firstBusStop.name) + "(기점)", 1 /* TEXT */),
      _hoisted_6,
      _createElementVNode("span", null, _toDisplayString($setup.lastBusStop.name) + "(종점)", 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createCommentVNode(" 경로보기 / 지도보기 "),
      ($props.shouldShowTurnPathBtn)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn path",
            type: "button",
            "aria-label": $setup.turnPathBtnTitle,
            onClick: $setup.emitOnClickLineTurnPathBtn
          }, [
            _createVNode($setup["InlineSvg"], {
              class: "map-icon",
              src: require('@/assets/icons/map.svg'),
              alt: $setup.turnPathBtnTitle,
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, ["src", "alt"]),
            _createTextVNode(" " + _toDisplayString($setup.turnPathBtnTitle), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_8))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 상세 "),
      _createElementVNode("button", {
        class: "btn detail",
        type: "button",
        onClick: $setup.emitOnClickDetailBtn,
        "aria-label": "상세"
      }, [
        _createVNode($setup["InlineSvg"], {
          class: "info-icon",
          src: require('@/assets/icons/info.svg'),
          alt: "상세",
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, ["src"]),
        _createTextVNode(" 상세 ")
      ]),
      _createCommentVNode(" 즐겨찾기 "),
      ($props.shouldShowFavoriteBtn)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn favorite",
            type: "button",
            "aria-label": $props.isFavoriteLine ? '즐겨찾기 해제' : '즐겨찾기 추가',
            onClick: $setup.emitOnClickFavoriteBtn
          }, [
            ($props.isFavoriteLine)
              ? (_openBlock(), _createBlock($setup["InlineSvg"], {
                  key: 0,
                  class: "star-filled-icon",
                  src: require('@/assets/icons/star-filled.svg'),
                  alt: "즐겨찾기",
                  "aria-hidden": "true"
                }, null, 8 /* PROPS */, ["src"]))
              : (_openBlock(), _createBlock($setup["InlineSvg"], {
                  key: 1,
                  class: "star-icon",
                  src: require('@/assets/icons/star.svg'),
                  alt: "즐겨찾기",
                  "aria-hidden": "true"
                }, null, 8 /* PROPS */, ["src"])),
            _createTextVNode(" 즐겨찾기 ")
          ], 8 /* PROPS */, _hoisted_9))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}